export { default } from '@esentai/core/features/questions/api';
